import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CleverPushNotification, CleverPushTopic, CleverPushTopicType } from '@zero/feature-clever-push/base';
import { PriceAlertDetails, PriceAlertsOverview } from '../entities/price-alerts.entity';

export const alertingActions = createActionGroup({
  source: 'Alerting',
  events: {
    loadTopics: emptyProps(),
    setTopicSubscription: props<{ topicName: string; status: boolean }>(),
    loadNotifications: emptyProps(),
    loadNotificationsFailure: emptyProps(),
    setNotifications: props<{ notifications: Record<string, CleverPushNotification<CleverPushTopicType | undefined>> }>(),
    loadPriceAlertOverview: emptyProps(),
    loadPriceAlertDetails: props<{ isin: string }>(),
    createPriceAlert: props<{ priceAlert: PriceAlertDetails; skipError?: boolean }>(),
    updatePriceAlertDetails: props<{ priceAlert: PriceAlertDetails }>(),
    deletePriceAlert: props<{ isin: string }>(),
    subscribeToPriceAlertDetailsQuote: props<{ isin: string }>(),
    unsubscribeFromPriceAlertDetailsQuote: props<{ isin: string }>(),
    updatePriceAlertQuote: props<{ quote: number }>(),
    setVolaAlertActive: props<{ active: boolean }>(),
    setQuoteAlertActive: props<{ active: boolean }>(),
  },
});

export const alertingApiActions = createActionGroup({
  source: 'Alerting API',
  events: {
    loadTopicsSuccess: props<{ topics: Record<string, CleverPushTopic> }>(),
    loadTopicsFailure: props<{ error: HttpErrorResponse }>(),
    setTopicSubscriptionSuccess: props<{ topicName: string; status: boolean }>(),
    setTopicSubscriptionFailure: props<{ topicName: string; error: HttpErrorResponse }>(),
    loadPriceAlertOverviewSuccess: props<{ priceAlertOverview: PriceAlertsOverview[] }>(),
    loadPriceAlertOverviewFailure: props<{ error: HttpErrorResponse }>(),
    loadPriceAlertDetailsSuccess: props<{ priceAlert: PriceAlertDetails }>(),
    loadPriceAlertDetailsFailure: props<{ error: HttpErrorResponse }>(),
    createPriceAlertSuccess: props<{ priceAlert: PriceAlertDetails; withoutToast?: boolean }>(),
    createPriceAlertFailure: props<{ error: HttpErrorResponse; skipError: boolean }>(),
    updatePriceAlertDetailsSuccess: props<{ priceAlert: PriceAlertDetails }>(),
    updatePriceAlertDetailsFailure: props<{ error: HttpErrorResponse }>(),
    deletePriceAlertSuccess: props<{ isin: string }>(),
    deletePriceAlertFailure: props<{ error: HttpErrorResponse }>(),
  },
});
